/* eslint-disable react/no-unknown-property */
import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10.0007" r="6.66667" fill="#7876C1" />
    <path
      d="M10 17.5C5.85775 17.5 2.5 14.1423 2.5 10C2.5 5.85775 5.85775 2.5 10 2.5C14.1423 2.5 17.5 5.85775 17.5 10C17.5 14.1423 14.1423 17.5 10 17.5ZM13.615 13.807C14.5203 12.9489 15.0906 11.7965 15.2235 10.5562C15.3565 9.31592 15.0435 8.06883 14.3406 7.03833C13.6377 6.00783 12.5909 5.26127 11.3876 4.93239C10.1844 4.60351 8.90333 4.7138 7.774 5.2435L8.50525 6.55975C9.07594 6.31172 9.69939 6.2096 10.3194 6.26259C10.9394 6.31559 11.5365 6.52205 12.0568 6.86335C12.5771 7.20464 13.0043 7.67006 13.2999 8.21763C13.5955 8.76521 13.7502 9.37774 13.75 10H11.5L13.615 13.807ZM12.226 14.7565L11.4948 13.4403C10.9241 13.6883 10.3006 13.7904 9.6806 13.7374C9.0606 13.6844 8.46353 13.478 7.94321 13.1367C7.4229 12.7954 6.99569 12.3299 6.7001 11.7824C6.40451 11.2348 6.24983 10.6223 6.25 10H8.5L6.385 6.193C5.47967 7.0511 4.90945 8.20352 4.77649 9.4438C4.64354 10.6841 4.95654 11.9312 5.65942 12.9617C6.36231 13.9922 7.40914 14.7387 8.61239 15.0676C9.81563 15.3965 11.0967 15.2862 12.226 14.7565Z"
      fill="#C7BCE4"
    />
  </svg>
);

const RefreshIcon = (props) => <Icon component={svg} {...props} />;

export default RefreshIcon;
